import React from 'react';

import {
  useBeginSubscriptionQuery as useBaseBeginSubscriptionQuery,
  useEndTrialEarlyMutation
} from 'generated/graphql';
import moment from 'moment';



export function useBeginSubscriptionQuery() {
  const beginSubscriptionTuple = useBaseBeginSubscriptionQuery();
  const [fnEndTrialEarlyMutate, endTrialEarlyTuple] = useEndTrialEarlyMutation();



  const data = React.useMemo(() => {
    const subscriptionInfo = beginSubscriptionTuple.data?.loggedInUser?.subscriptionInfo;
    if (!subscriptionInfo) {
      return null;
    }

    return {
      status: subscriptionInfo.status,
      dayLeft: moment(subscriptionInfo.currentPeriodEnd).diff(moment(), 'day')
    };
  }, [beginSubscriptionTuple]);



  return {
    data,
    queryLoading: beginSubscriptionTuple.loading,
    queryRefetch: () => beginSubscriptionTuple.refetch(),
    endTrialEarlyMutateLoading: endTrialEarlyTuple.loading,
    fnEndTrialEarlyMutate
  };
}
